import * as React from "react";
import ConnectionSidebar from "../Connection/ConnectionSidebar";
import { createBrowserHistory } from "history";
import {
  LoadConnection,
  GetConnectionList,
  CreateConnection,
  UpdateConnection,
  DeleteConnection
} from "../../../../actions/ConnectionActions";
import ConnectionStore from "../../../../stores/ConnectionStore";
import { Link } from "react-router-dom";
const customHistory = createBrowserHistory();
function maskConnectionStringPassword(connectionString) {
  if (!connectionString) return connectionString;
  return connectionString.replace(/Password=[^;]*/i, "Password=**********");
}
class ConnectionView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentConnection: {
        id: 0,
        name: "",
        connectionString: ""
      },
      connectionId: 0,
      isDirty: false,
      error: "",
      isSaving: false,
      deleteStatus: 0,
      showPassword: false
    };
    this.updateConnection = this.updateConnection.bind(this);
    this.onStoreUpdate = this.onStoreUpdate.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleConnectionStringChange = this.handleConnectionStringChange.bind(this);
    this.handleSaveClick = this.handleSaveClick.bind(this);
    this.toggleShowPassword = this.toggleShowPassword.bind(this);
    this.startDelete = this.startDelete.bind(this);
    this.deleteConnection = this.deleteConnection.bind(this);
    this.cancelDelete = this.cancelDelete.bind(this);
  }
  componentDidMount() {
    ConnectionStore.addChangeListener(this.onStoreUpdate);
    this.updateConnection();
  }
  componentWillUnmount() {
    ConnectionStore.removeChangeListener(this.onStoreUpdate);
  }
  componentDidUpdate() {
    this.updateConnection();
  }
  updateConnection() {
    let loc = window.location.pathname;
    let pathParts = loc.split("/");
    let connectionId = parseInt(pathParts[pathParts.length - 1], 10);
    if (connectionId !== 0 && (this.state.currentConnection === void 0 || this.state.currentConnection.id !== connectionId)) {
      console.log("load conn");
      LoadConnection(connectionId);
    } else if (connectionId === 0 && this.state.currentConnection !== void 0 && this.state.currentConnection.id !== 0) {
      let currentConnection = {};
      currentConnection.id = 0;
      currentConnection.name = "";
      currentConnection.connectionString = "";
      this.setState({
        currentConnection,
        connectionName: ""
      });
    }
  }
  onStoreUpdate() {
    let lastAction = ConnectionStore.lastChange();
    if (lastAction === "ConnectionLoadOne") {
      let connection = ConnectionStore.getCurrentConnection();
      console.log(connection);
      this.setState({
        currentConnection: connection,
        connectionName: connection.name,
        isDirty: false,
        isSaving: false,
        showPassword: false
      });
    }
    if (lastAction === "ConnectionCreateOne") {
      let lastError = ConnectionStore.getLastError();
      if (lastError === "" || lastError === void 0) {
        let newConnection = ConnectionStore.getCurrentConnection();
        if (newConnection.id !== this.state.currentConnection.id) {
          customHistory.push(`/Admin/ConnectionView/${newConnection.data.id}`);
        }
        this.setState({
          error: "",
          currentConnection: newConnection,
          currentName: newConnection.name,
          isSaving: false,
          isDirty: false
        });
        GetConnectionList();
      } else {
        this.setState({ isSaving: false, error: lastError });
      }
    }
    if (lastAction === "ConnectionUpdateOne") {
      let lastError = ConnectionStore.getLastError();
      if (lastError === "" || lastError === void 0) {
        let newConnection = ConnectionStore.getCurrentConnection();
        if (newConnection.data.id !== this.state.currentConnection.id) {
          customHistory.push(`/Admin/ConnectionView/${newConnection.data.id}`);
        }
        this.setState({
          error: "",
          currentConnection: newConnection,
          currentName: newConnection.name,
          isSaving: false,
          isDirty: false
        });
        GetConnectionList();
      } else {
        this.setState({ isSaving: false, error: lastError });
      }
    }
    if (lastAction === "ConnectionDelete") {
      let lastError = ConnectionStore.getLastError();
      if (lastError === "") {
        let link = document.getElementById("connectionHome");
        link.click();
      } else {
        this.setState({ isSaving: false, error: lastError });
      }
    }
  }
  handleNameChange(e) {
    let currentConnection = this.state.currentConnection;
    currentConnection.name = e.target.value;
    this.setState({ currentConnection, isDirty: true });
  }
  handleConnectionStringChange(e) {
    let currentConnection = this.state.currentConnection;
    currentConnection.connectionString = e.target.value;
    this.setState({ currentConnection, isDirty: true });
    console.log(currentConnection);
    console.log(this.state.currentConnection);
  }
  handleSaveClick(e) {
    this.setState({ isSaving: true });
    if (this.state.currentConnection.id === 0) {
      CreateConnection(this.state.currentConnection);
    } else {
      UpdateConnection(this.state.currentConnection);
    }
  }
  startDelete() {
    this.setState({ deleteStatus: 1 });
  }
  deleteConnection() {
    DeleteConnection(this.state.currentConnection.id);
    this.setState({ deleteStatus: 0 });
  }
  cancelDelete() {
    this.setState({ deleteStatus: 0 });
  }
  toggleShowPassword() {
    this.setState({ showPassword: !this.state.showPassword });
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: "container-fluid", style: { height: "100%" } }, /* @__PURE__ */ React.createElement("div", { className: "row flex-nowrap", style: { height: "100%" } }, /* @__PURE__ */ React.createElement(ConnectionSidebar, null), /* @__PURE__ */ React.createElement(
      Link,
      {
        id: "connectionHome",
        className: "nav-link",
        to: `/Admin/Connection`,
        style: { display: "none" }
      }
    ), this.state.currentConnection !== void 0 && /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "flex-fill",
        style: { backgroundColor: "#efefef", overflow: "scroll" }
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "card",
          style: {
            marginTop: "20px",
            marginLeft: "30px",
            marginRight: "30px",
            maxHeight: "620px"
          }
        },
        /* @__PURE__ */ React.createElement("div", { className: "card-header" }, /* @__PURE__ */ React.createElement("h4", null, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-database" }), "  ", this.state.currentConnection.name)),
        /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "mb-3" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "nameTxt", className: "form-label" }, "Name:"), /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "text",
            className: "form-control",
            id: "nameTxt",
            value: this.state.currentConnection.name,
            onChange: this.handleNameChange
          }
        )), /* @__PURE__ */ React.createElement("div", { className: "mb-3" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "valueTxt", className: "form-label" }, "Value:"), /Password=/i.test(this.state.currentConnection.connectionString) && !this.state.isDirty ? /* @__PURE__ */ React.createElement("div", { className: "input-group" }, /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "text",
            className: "form-control",
            id: "valueTxt",
            value: this.state.showPassword ? this.state.currentConnection.connectionString : maskConnectionStringPassword(this.state.currentConnection.connectionString),
            readOnly: !this.state.showPassword,
            onChange: this.handleConnectionStringChange
          }
        ), /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-outline-secondary",
            type: "button",
            onClick: this.toggleShowPassword,
            title: this.state.showPassword ? "Hide password" : "Show password"
          },
          /* @__PURE__ */ React.createElement("i", { className: `fa-solid ${this.state.showPassword ? "fa-eye-slash" : "fa-eye"}` })
        )) : /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "text",
            className: "form-control",
            id: "valueTxt",
            value: this.state.currentConnection.connectionString,
            onChange: this.handleConnectionStringChange
          }
        )), /* @__PURE__ */ React.createElement("div", { className: "mb-3", style: { marginTop: "8px" } }, this.state.isDirty && !this.state.isSaving && /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-primary",
            onClick: this.handleSaveClick
          },
          "Save"
        ), !this.state.isDirty && !this.state.isSaving && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", { className: "btn btn-primary disabled" }, "Save"), /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-danger",
            style: { marginLeft: "6px" },
            onClick: this.startDelete
          },
          "Delete"
        )), this.state.isSaving && /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-spinner", size: "2x", spin: true }), this.state.deleteStatus === 1 && /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "alert alert-danger",
            style: { marginTop: "6px" },
            role: "alert"
          },
          /* @__PURE__ */ React.createElement("p", null, "Are you sure you want to delete this connection?"),
          /* @__PURE__ */ React.createElement(
            "button",
            {
              className: "btn btn-danger",
              onClick: this.deleteConnection
            },
            "Yes - Delete"
          ),
          /* @__PURE__ */ React.createElement(
            "button",
            {
              className: "btn btn-secondary",
              style: { marginLeft: "6px" },
              onClick: this.cancelDelete
            },
            "Cancel"
          )
        ), this.state.error !== "" && /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "alert alert-danger",
            style: { marginTop: "6px" },
            role: "alert"
          },
          this.state.error
        )))
      )
    )));
  }
}
export default ConnectionView;
